
import BannerContainer from '~/components/child/banner/BannerContainer.vue';
import TagContainer from '~/components/child/tag/TagContainer.vue';
import RecipeContainer from '~/components/child/recipe/RecipeContainer.vue';
import BrowseContainer from '~/components/child/browse/BrowseContainer.vue';
import ArticleChannelContainer from '~/components/child/article/ArticleChannelContainer.vue';
import BloggerRankingChannel from '~/components/child/blogger/BloggerRankingChannel.vue';
import ArticleHotContainer from '~/components/child/article/ArticleHotContainer.vue';
export default {
    name: "travel",
    components: { BannerContainer, TagContainer, RecipeContainer, BrowseContainer, ArticleChannelContainer, BloggerRankingChannel, ArticleHotContainer },
    head() {
        return {
            title: '寵物-PIXNET痞客邦',
            meta: [
                { hid: 'description', name: 'description', content: '痞客邦寵物愛好者最佳交流平台！創作、分享、閱讀，全方位滿足你的寵物熱情。寫下動人故事，傳達你與毛孩的默契；探索他人心情，共享寵物養育心得。痞客邦，寵物話題的熱鬧集結地，邀你加入，彼此連結，讓寵物的溫馨故事在這裡綻放。快來展開鍵盤上的舞蹈，綻放你對寵物的愛！' },
                { hid: 'og:description', name: 'og:description', property: 'og:description', content: '痞客邦寵物愛好者最佳交流平台！創作、分享、閱讀，全方位滿足你的寵物熱情。寫下動人故事，傳達你與毛孩的默契；探索他人心情，共享寵物養育心得。痞客邦，寵物話題的熱鬧集結地，邀你加入，彼此連結，讓寵物的溫馨故事在這裡綻放。快來展開鍵盤上的舞蹈，綻放你對寵物的愛！' },
                { hid: 'twitter:description', name: 'twitter:description', property: 'twitter:description', content: '痞客邦寵物愛好者最佳交流平台！創作、分享、閱讀，全方位滿足你的寵物熱情。寫下動人故事，傳達你與毛孩的默契；探索他人心情，共享寵物養育心得。痞客邦，寵物話題的熱鬧集結地，邀你加入，彼此連結，讓寵物的溫馨故事在這裡綻放。快來展開鍵盤上的舞蹈，綻放你對寵物的愛！' },
                { hid: 'keywords', name: 'keywords', content: '寵物部落格、寵物愛好者、寵物交流平台、寵物故事分享、寵物養育心得、寵物話題熱門、寵物溫馨故事、寵物心情探索、寵物熱情連結、寵物寫真、寵物生活技巧、可愛寵物照片、寵物健康護理、寵物訓練秘訣、寵物飲食建議、寵物活動與娛樂、寵物種類介紹、寵物新知發現、寵物周邊商品推薦、寵物日常趣聞' },
                { hid: 'og:title', name: 'og:title', property: 'og:title', content: "寵物-PIXNET痞客邦"},
                { property: 'og:image', property: 'og:image', content: "https://www.pixnet.net/img/public/og/img_pet_og.png"},
                { property: 'og:image:secure_url', property: 'og:image:secure_url', content: "https://www.pixnet.net/img/public/og/img_pet_og.png"},
                { property: 'twitter:image', property: 'twitter:image', content: "https://www.pixnet.net/img/public/og/img_pet_og.png"},
                { property: 'image', name: 'image', itemprop: 'image', content: "https://www.pixnet.net/img/public/og/img_pet_og.png"},
            ],
            link: [
                { rel: 'canonical', href: 'https://www.pixnet.net/channel/pet', key: "canonical"}
            ]
        }
    },
    jsonld() {
        return {
            "@context": " https://schema.org/",
            "@graph": [
                {
                    "@context":"https://schema.org",
                    "@type":"Organization",
                    "url":"https://www.pixnet.net",
                    "logo":"https://www.pixnet.net/img/public/og/img_pet_og.png",
                    "name":"痞客邦",
                    "@id":"https://www.pixnet.net/#organization",
                    "description":"痞客邦寵物愛好者最佳交流平台！創作、分享、閱讀，全方位滿足你的寵物熱情。寫下動人故事，傳達你與毛孩的默契；探索他人心情，共享寵物養育心得。痞客邦，寵物話題的熱鬧集結地，邀你加入，彼此連結，讓寵物的溫馨故事在這裡綻放。快來展開鍵盤上的舞蹈，綻放你對寵物的愛！",
                    "address":"",
                    "brand":{
                        "@type":"Brand",
                        "logo":"https://www.pixnet.net/img/public/og/img_pet_og.png"
                    },
                    "sameAs":"https://www.facebook.com/pixnet.net"
                },
                {
                    "@context":"https://schema.org/",
                    "@type":"BreadcrumbList",
                    "itemListElement":[
                        {
                            "@type": "ListItem",
                            "position": 1,
                            "name": "寵物-PIXNET痞客邦",
                            "item": "https://www.pixnet.net",
                            "description": "痞客邦寵物愛好者最佳交流平台！創作、分享、閱讀，全方位滿足你的寵物熱情。寫下動人故事，傳達你與毛孩的默契；探索他人心情，共享寵物養育心得。痞客邦，寵物話題的熱鬧集結地，邀你加入，彼此連結，讓寵物的溫馨故事在這裡綻放。快來展開鍵盤上的舞蹈，綻放你對寵物的愛！",
                            "keywords": "寵物部落格、寵物愛好者、寵物交流平台、寵物故事分享、寵物養育心得、寵物話題熱門、寵物溫馨故事、寵物心情探索、寵物熱情連結、寵物寫真、寵物生活技巧、可愛寵物照片、寵物健康護理、寵物訓練秘訣、寵物飲食建議、寵物活動與娛樂、寵物種類介紹、寵物新知發現、寵物周邊商品推薦、寵物日常趣聞"
                        }
                    ]
                }
            ]
        }
    },
    data() {
        return {
            channel_page_id: 11,
            category_id: 3,
            showAnimation: false,
        }
    },
    computed: {
        is_login() {
            return this.$store.state.login.login_status;
        },
        pa_page_name() {
            return '寵物';
        },
        tag_search_text() {
            return '寵物';
        },
        day_hot_article() {
            return this.$store.state.article.day_hot_article;
        },
        day_hot_article_full() {
            return this.$store.state.article.day_hot_article_full;
        }
    },
    methods: {
        paFunction() {
            window._piq.push(['trackEvent', 'rs2022::十大頻道::' + this.pa_page_name, 'imps::頁面::page::user_action', '', '']);
        },
        paScrollFunction(){
            addEventListener("scroll", () => {
                window._piq.push(['trackEvent', 'rs2022::十大頻道::' + this.pa_page_name, 'scroll::頁面::page::user_action', '', '']);
            }, { once: true });
        },
        gtag(){
            window.dataLayer.push(arguments);
        },
        activeGaPage() {
            this.gtag('config', 'G-RPGK0ML6QM', {
                'channel_category': '寵物'
            });
            this.gtag('config', 'G-45SMZ66RLZ', {
                'channel_category': '寵物'
            });
            this.gtag('event', 'page_view', {
                page_title: '寵物-PIXNET痞客邦',
            });
        },
        activeMcPage() {
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "kbvat69or6");
        },
    },
    async fetch(){
        const item = { sort: 'hot', type: 'category', pre_page: 10, id: 3, ver: 2 }
        await this.$store.dispatch("article/getDayHotArticle", item);
    },
    mounted() {
        window.dataLayer = window.dataLayer || [];
        this.activeGaPage();
        this.activeMcPage();
        this.paFunction();
        this.paScrollFunction();
    }
}
